import FieldValueInput from '@UI/Pages/Subjects/Shared/Fields/FieldValueInput';
import type FieldDraft from '@UI/Pages/Subjects/Shared/FormData/FieldDraft';
import type FieldValueFormData from '@UI/Pages/Subjects/Shared/FormData/FieldValueFormData';
import * as React from 'react';

type Props = {
	readonly entry: FieldValueFormData;
	readonly onValueChange: (key: string, value: FieldDraft) => void;
};

/** One field of the sheet, bound to its own entry of the form. */
const SheetField: React.FC<Props> = ({ entry, onValueChange }) => {
	const key = entry.definition.key;

	const handleChange = React.useCallback(
		(value: FieldDraft) => {
			onValueChange(key, value);
		},
		[key, onValueChange],
	);

	return (
		<FieldValueInput
			definition={entry.definition}
			value={entry.value}
			onChange={handleChange}
			errorMessage={entry.errorMessage}
			isFormFieldValid={entry.isShownValid}
		/>
	);
};

export default SheetField;
